import type { EmblaOptionsType } from "embla-carousel";

// import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";

type PropType = {
	slides: Array<JSX.Element>;
	options?: EmblaOptionsType;
};

const EmblaCarouselMVP: React.FC<PropType> = (props) => {
	const { slides, options } = props;
	// const [emblaRef] = useEmblaCarousel(options, [Autoplay()]);
	const [emblaRef] = useEmblaCarousel(options, []);

	return (
		<section className="embla">
			<div ref={emblaRef} className="embla__viewport">
				<div className="embla__container">
					{slides.map((element, index) => (
						<div key={index} className="embla__slide__v1">
							{element}
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default EmblaCarouselMVP;
